import React from 'react';

type Props = {}

const Explained: React.FC<Props> = (props) => {
  return (
    <div>
      <h2 className="ml-3 mb-2 text-xl font-bold">使い方</h2>
      <p className="ml-6 mb-4 text-lg ">前日に登板していないことを前提とした当日～3日後までのシミュレーションと投球数記録が可能です</p>
      <p className="ml-6 mb-1 text-lg ">[セーブ]：現在の記入データをPCに登録します</p>
      <p className="ml-6 mb-1 text-lg ">[ロード]：登録されたデータをロードします。データがない場合は更新されません</p>
      <p className="ml-6 mb-1 text-lg ">[データ整列]：「チーム名」順に揃えて、背番号順に並べ替えます</p>
      <p className="ml-6 mb-1 text-lg ">[Excelで上書き]：現在のデータを消して、エクセルからのデータを表示します</p>
      <p className="ml-6 mb-1 text-lg ">[Excelから追加]：現在のデータを残して、エクセルからのデータを追加・表示します</p>
      <p className="ml-6 mb-1 text-lg ">[Excel出力]：現在表示中のデータをエクセルファイルに出力します</p>
      <p className="ml-6 mb-1 text-lg ">[全球数クリア]：全員の投球データをクリアします</p>
      <p className="ml-6 mb-4 text-lg ">[全データ消去]：すべての記入されたデータを消去します</p>
      <p className="ml-6 mb-1 text-lg ">日付を変更してもデータはスライドされません。日付を合わせるためにご使用ください</p>
    </div>
  );
};

export default Explained;
